import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axiosInstance from "../../Helper/axiosInstance";
import { mimeTypeConvertor } from "../Helper/mimeTypeConvertor";

const useUserData = () => {
    const [searchParam] = useSearchParams();
    // تغییر نام پارامتر از useParams
    const { id, landingUrlsId } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
    const [inputNeeded, setIsInputNeeded] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const optionToken = searchParam.get('token');
        const optionData = searchParam.get('data');

        const token = optionToken ? optionToken : optionData;

        if (!token) return;

        setIsLoading(true);

        const payload = {
            id,
            token,
            ...(landingUrlsId && { landingUrlsId })
        };

        axiosInstance.post(`https://shadeventapi.noyanet.com/rubika/LoginByToken`, payload)
            .then(({ data }) => {
                if (data.data.background) {
                    localStorage.setItem('backgroundURL', data.data.background);
                }

                if (data.data.extention) {
                    localStorage.setItem('ext', mimeTypeConvertor(data.data.extention))
                }

                setIsLoading(false);

                if (!!data.data?.url) {
                    window.location.replace(data.data.url.replace(".ir:443", ".ir"));
                    setIsUserAuthenticated(true);
                    return;
                }

                localStorage.setItem('phoneNumber', data.data.mobile)

                if (data.status === 200) {
                    navigate(`/${id}/file`);
                    return;
                }

                setIsUserAuthenticated(false);
                setIsInputNeeded(!(data.data.mobile.length > 0));
            })
            .catch(({ data }) => {
                const status = data?.status;

                if (status === 401 || status === 208) {
                    setMessage(data.message);
                    return;
                }

                if (status === 203 || status === 400 || status === 500) {
                    localStorage.setItem('phoneNumber', data.data.mobile)
                    setIsLoading(false);
                    setIsInputNeeded(true);
                    setIsUserAuthenticated(false);
                }
            })

    }, [id, landingUrlsId]);

    return {
        isLoading,
        isUserAuthenticated,
        inputNeeded,
        message,
    }
}

export default useUserData;